<template>
  <div class="cer-source">
    <div v-if="showNone == 2">
      <div class="authTip">
        <i class="icon icon-authTip"></i>
        <div>
          <p>认证源</p>
          <p>{{ topText }}</p>
        </div>
      </div>
      <div class="no-userContact-btn">
        欢迎使用第三方认证源。<i @click="dialogAddVisible = true">去添加</i>
      </div>
    </div>
    <div v-if="showNone == 3">
      <div class="btns">
        <el-button
          type="primary"
          size="small"
          class="addGroup"
          @click="dialogAddVisible = true"
        >
          添加
        </el-button>
      </div>
      <el-table :data="tableData" tooltip-effect="light" style="width: 100%">
        <el-table-column
          label="认证源名称"
          prop="name"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="enabled"
          label="启用状态"
          width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.enabled"
              @input="enableChange(scope.row.enabled, scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="200px"
          align="center"
          class-name="options td-pt1"
        >
          <template slot-scope="scope">
            <span class="textBtn" @click="handleDetail(scope.row, true)">
              详情
            </span>
            <span
              class="textBtn delete"
              @click="handleDelete(scope.row.providerId)"
            >
              删除
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        :page-size="pageSize"
        :current-page.sync="pageNum"
        :total="total"
        @current-change="pageChange"
      >
      </el-pagination>
      <el-dialog title="删除提示" width="500px" :visible.sync="dialogRemove">
        <div class="deleteText">确认删除这个认证源吗？</div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="deleteProvider">确 定</el-button>
          <el-button @click="dialogRemove = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="选择认证源"
      width="600px"
      :visible.sync="dialogAddVisible"
    >
      <div class="source-box">
        <p v-if="providerList.length < 1" class="deleteText">其他认证源持续更新中，敬请期待。</p>
        <div v-else>
          <div
            v-for="(item, index) in providerList"
            :key="index"
            @click="handleDetail(item, false)"
          >
            <img :src="item.url" :alt="item.name" />
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import APIS from "@/apis/certificationSource.js"
export default {
  data() {
    return {
      moduleTitle: "认证源",
      breadcrumb: [
        {
          label: "认证源"
        }
      ],
      dialogAddVisible: false,
      dialogRemove: false,
      showNone: 1,
      realmName: this.$realm,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      sourceId: "",
      tableData: [],
      providerList: [],
      topText:
        "本平台支持企业使用不同的外部认证源（即允许使用第三方认证方式登录账户）。启用认证源后并配置完成后，平台会允许企业用户登录时使用具体的认证源去认证。"
    }
  },
  mounted() {
    this.getProviderList()
    this.getAbleProviderList()
  },
  methods: {
    // 查询已配置认证源列表
    async getProviderList() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      let { data } = await APIS.getProviderList(this.realmName, {
        params
      })
      this.total = 0
      this.tableData = []
      if (data) {
        this.showNone = data.totalCount == 0 ? 2 : 3
        this.total = data.totalCount
        this.tableData = data.data
      }
    },
    // 获取可配置认证源列表
    async getAbleProviderList() {
      let { data } = await APIS.getAbleProviderList(this.realmName)
      if (data) {
        this.providerList = []
        for (let key in data) {
          let item = {
            name: data[key],
            providerId: key,
            url: require(`@/assets/images/${key}.png`)
          }
          this.providerList.push(item)
        }
      }
    },
    // 查看认证源详情
    handleDetail(row, type) {
      this.$router.push({
        path: `/certificationSource/${!type ? "addSource" : "detail"}`,
        query: {
          sourceID: row.providerId,
          name: row.name
        }
      })
    },
    // 删除认证源
    handleDelete(id) {
      this.sourceId = id
      this.dialogRemove = true
    },
    // 切换认证源的启用状态
    async enableChange(enabled, row) {
      row.enabled = !enabled
      let apiName = row.providerId == "cas" ? "editCasProvider" : 'editProvider'
      // [poxName]
      let { status } = await APIS[apiName](
        this.realmName,
        {
          data: row
        },
        row.providerId
      )
      if (status != 0) {
        row.enable = enabled
      } else {
        this.getProviderList()
      }
    },
    // 切换分页
    pageChange() {
      this.getProviderList()
    },
    // 确认删除认证源
    async deleteProvider() {
      this.dialogRemove = false
      let { status } = await APIS.deleteProvider(this.realmName, this.sourceId)
      if (status === 0) {
        if (this.total === 1) {
          this.pageNum = 1
        } else if ((this.total - 1) % this.pageSize === 0) {
          this.pageNum -= 1
        }
        this.getProviderList()
        this.getAbleProviderList()
      }
    }
    //
  }
}
</script>

<style lang="scss">
.cer-source {
  .no-userContact-btn {
    position: absolute;
    top: 50%;
    font-weight: 500;
    font-size: 16px;
    left: 50%;
    margin: -100px 0 0 -100px;
    i {
      border-bottom: 1px solid #4497ec;
      font-style: normal;
      color: #4497ec;
      cursor: pointer;
    }
  }
  .source-box {
    padding: 20px;
    height: auto;
    div {
      height: auto;
      display: flex;
      flex-wrap: wrap;
			justify-content: space-between;
      div {
        width: 130px;
        height: 120px;
        border: 1px solid #ebeef5;
        border-radius: 5px;
        margin: 10px 10px;
        img {
          display: block;
          outline: none;
          width: 50px;
          height: 50px;
          margin: 10px auto;
        }
        span {
          display: block;
          width: 100%;
          height: 20px;
          line-height: 20px;
          text-align: center;
        }
        &:hover {
          box-shadow: 0 2px 12px 0 #ccc;
        }
      }
    }
  }
  .none-tips {
    align-items: center;
    justify-content: space-around;
    .none-tips {
      display: block;
    }
  }
  .btns {
    margin: 0 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
  }
}
.page-title {
  margin-bottom: 16px;
}
</style>